'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // This component is an editable (= items are removable) shopping cart, not the
// shopping cart that is  tab controller.

exports.checkTravelPackage = checkTravelPackage;

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkTravelPackage(messageService, cancelService, pending, products) {
  // Cancel pending request
  if (pending) {
    cancelService.cancel(pending);
  }

  // Return request for canceling
  return messageService.checkTravelPackage(products);
}

var WinresShoppingCartController = function () {
  function WinresShoppingCartController($scope, $filter, $rootScope, $q, userService, localizationService, messageService, cancelService, productService, discountService, $timeout) {
    _classCallCheck(this, WinresShoppingCartController);

    this.$scope = $scope;
    this.$filter = $filter;
    this.contents = [];
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.user = null;
    this.userService = userService;
    this.localizationService = localizationService;
    this.$scope.summaryInfo = null;
    this.$scope.summaryInfoHeader = null;
    this.$scope.totalProductAmoun = null;
    this.messageService = messageService;
    this.cancelService = cancelService;
    this.productService = productService;
    this.discountService = discountService;
    this.$timeout = $timeout;
    this.messageToBooking = '';
  }

  _createClass(WinresShoppingCartController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Dependencies
      // this.winresReservationContext

      // Get:
      // getContext()
      // getContext().Products
      // getContext().NumAdults
      // getContext().NumChildren
      // getReservationFee()

      // Set:
      // getContext().Products        

      if (this.context) {
        this.winresReservationContext = this.context;
      }

      if (!this.winresReservationContext) {
        if (window.definiteWinresReservationContext) {
          console.log('[winres-shopping-cart]', 'Context is not available. Falling back to global.');
          this.winresReservationContext = window.definiteWinresReservationContext;
        } else {
          throw new Error('A context is required.');
        }
      }

      this.data = this.winresReservationContext.getContext();

      this.language = this.localizationService.getLanguage();

      // console.log(this.data);

      // Watch products array
      this.$scope.$watchCollection(function () {
        return _this.data.Products;
      }, function () {

        // Disable watches
        if (_this.productWatches) {
          _.each(_this.productWatches, function (productWatch) {
            return productWatch();
          });
        }

        _this.productWatches = [];

        // Watch products array keys
        _.each(_this.data.Products, function (product) {
          var productWatch = _this.$scope.$watchGroup([function () {
            return product.Amount;
          }, function () {
            return product.TotalPrice;
          }, function () {
            return product.UnitPrice;
          }, function () {
            return product.PriceSelections;
          }, function () {
            return product.Product.BeginDate;
          }, function () {
            return product.Product.EndDate;
          }], function () {
            _this.updateContentsDelay();
          }, true);
          _this.productWatches.push(productWatch);
        });

        _this.updateContentsDelay();
      }, true);

      this.$scope.$watchCollection(function () {
        return _this.data.DiscountProducts;
      }, function () {
        _this.updateContentsDelay();
      }, true);

      // Discount code input in shopping cart.
      this.checkDiscountCodeVisibility();

      this.messageCode = this.messageCode || 'WRCNOT';

      if (this.messageCode === 'WRCNOT') {
        this.getMessageHeader();
      }

      this.$scope.$watch('$ctrl.messageToBooking', function () {
        _this.winresReservationContext.setMessageToBooking(_this.messageToBooking);
      });
    }
  }, {
    key: 'checkDiscountCodeVisibility',
    value: function checkDiscountCodeVisibility() {
      var _this2 = this;

      this.$scope.$watch(function () {
        return _this2.userService.getCurrentUser();
      }, function (user) {
        if (user) {
          // Discount field visiblity from Winres.
          var discountInUse = user.getParameter('DiscountInUse') === 'TRUE';

          // Show discount code field in shopping cart.
          _this2.$scope.showDiscountCode = discountInUse && _this2.showDiscountCode && _this2.showDiscountCode === 'true';

          // Discount code field in shopping cart.
          _this2.discountCode = _this2.discountService.getDiscountCodeFromLocalStorage();
        }
      });
    }
  }, {
    key: 'useDiscountCode',
    value: function useDiscountCode() {
      var _this3 = this;

      this.loadingDiscountCode = true;

      if (this.pending) {
        this.cancelService.cancel(this.pending);
        this.pending = null;
      }

      var request = this.discountService.useDiscountCode(this.discountCode, this.data.Products, this.data.Passengers);
      this.pending = request;

      request.then(function (discounts) {
        if (discounts == null) {
          // Canceled.
          return;
        }

        // Clear exising discount products.
        _this3.discountService.clearDiscountProductsFromCart(_this3.winresReservationContext);

        if (discounts.length > 0) {
          // Found discounts, add them to shopping cart.

          _.each(discounts, function (d) {
            _this3.discountService.addDiscountProductToCart(_this3.winresReservationContext, _this3.discountCode, d.Price, d.DestCode, d.ProdCode, d.BeginDate, d.EndDate, d.Name, d.Scope);
          });

          // Update discount products for context.
          _this3.discountService.createDiscountProducts(_this3.winresReservationContext);

          // Prebook discount code.
          _this3.data.DiscountCode = _this3.discountCode;
        } else {
          // Discount code was not found, empty discount code and show error pop-up.

          // Empty discount code field.
          _this3.discountCode = '';

          // Empty prebook discount code.
          _this3.data.DiscountCode = '';

          _this3.$rootScope.$broadcast('popup-error', [{
            Message: _this3.$filter('i18next')('discount.error'),
            Params: {}
          }]);
        }
        // this.updateContents();
        _this3.loadingDiscountCode = false;
      });
    }
  }, {
    key: 'getMessageHeader',
    value: function getMessageHeader() {
      var _this4 = this;

      var language = this.language.charAt(0).toUpperCase() + this.language.slice(1);

      if (this.user) {
        this.summaryInfoHeader = this.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
      } else {
        var user = this.userService.getCurrentUser();
        if (user) {
          this.user = user;
          this.summaryInfoHeader = this.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
        }

        this.$rootScope.$on('userDataChanged', function () {
          _this4.user = _this4.userService.getCurrentUser();
          _this4.summaryInfoHeader = _this4.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
        });
      }
    }
  }, {
    key: 'checkTravelPackageMessage',
    value: function checkTravelPackageMessage() {
      var _this5 = this;

      this.pending = checkTravelPackage(this.messageService, this.cancelService, this.pending, this.data.Products).then(function (travelPackage) {
        _this5.showTravelPackageMessage = travelPackage && travelPackage.TravelPackageInUse;
      });
    }
  }, {
    key: 'closeShoppingBasket',
    value: function closeShoppingBasket() {
      if (window.closeShoppingBasket !== undefined) {
        // Close new shopping cart modal.
        window.closeShoppingBasket();
      }

      // Close old style jQuery modal.
      document.querySelector('#closeshoppingbasket').click();
    }

    // Reduce updateContents calls.

  }, {
    key: 'updateContentsDelay',
    value: function updateContentsDelay() {
      var _this6 = this;

      if (this.updateTimeout !== undefined) {
        // Cancel prevous timeout.
        this.$timeout.cancel(this.updateTimeout);
      }

      // Update after 100ms.
      this.updateTimeout = this.$timeout(function () {
        return _this6.updateContents();
      }, 100);
    }
  }, {
    key: 'updateContents',
    value: function updateContents() {
      var _this7 = this;

      //console.log("[WSC] Updating cart contents...");
      var products = this.data.Products;
      //console.log("[WSC] Updating cart contents... products: ", products);
      this.index = -1;

      if (this.data.DiscountProducts) {
        products = _.concat(products, this.data.DiscountProducts);
      }

      // Combine day linked products to single products.
      products = combineDayLinkedProducts(products);

      // Order the product lines, placing dependent lines (discounts and services)
      // below their parents.
      products = orderProductLines(products);

      this.contents = _.map(products, function (x) {
        return _this7.productLineDetails(x);
      });

      this.getReservationFee();
      this.refreshTotalProductAmount();
      this.findInvalidDateServices(products);
      this.validateExtraQuestions();
      this.checkTravelPackageMessage();

      // Extra question field red border
      if (!this.extraQuestionValidator && _.some(this.contents, function (c) {
        return c.extraQuestions && c.extraQuestions.length > 0;
      })) {
        this.$scope.$on('winresReservationShowErrors', function () {
          var forms = document.querySelectorAll('.extra-question-form');
          forms.forEach(function (form) {
            var scope = angular.element(form).scope();
            scope.form.textarea.$setDirty();
          });
        });
        this.extraQuestionValidator = true;
      }

      this.hasDestinationName = _.some(this.contents, function (c) {
        return c.destinationName;
      });

      //console.log("[WSC] updated cart: this.reservationFee: ", this.reservationFee);
      //console.log("Updated cart contents: ", this.contents);
      //console.log("Updated cart products. this.data.Products: ", this.data.Products);
    }
  }, {
    key: 'validateExtraQuestions',
    value: function validateExtraQuestions() {
      this.winresReservationContext.setReservationComponentErrors('extra_questions', 'extra_questions', []);

      var errors = [];
      _.each(this.contents, function (row) {
        _.each(row.extraQuestions, function (extraQuestion) {
          if (extraQuestion.Question && !extraQuestion.Answer) {
            errors.push({
              Message: 'shopping_cart.error_extra_question',
              Params: {
                question: extraQuestion.Question,
                name: row.destinationName
              }
            });
          }
        });
      });

      this.winresReservationContext.setReservationComponentErrors('extra_questions', 'extra_questions', errors);
    }
  }, {
    key: 'productLineDetails',
    value: function productLineDetails(line) {
      var dateRange;
      if (line.Product.BeginTime && line.Product.EndTime) {
        if (line.Product.BeginDate === line.Product.EndDate) {
          // Same day.
          // Begin date with begin and end time.
          dateRange = (0, _utils.formatDateWithTimes)(line.Product.BeginDate, line.Product.BeginTime, line.Product.EndTime);
        } else {
          // Date range with begin and end time.
          dateRange = (0, _utils.formatDateRange)(line.Product.BeginDate, line.Product.EndDate, line.Product.BeginTime, line.Product.EndTime);
        }
      } else if (line.Product.LinkingInfo && line.Product.LinkingInfo.Type === 'Day') {
        dateRange = (0, _utils.formatDateRange)(line.Product.BeginDate, line.Product.EndDate);
      } else if (line.Product.ForceReservedDays > 0 || !line.Product.DestinationInfo.Accommodation) {
        dateRange = (0, _utils.formatFinnishDatePretty)(line.Product.BeginDate);
      } else {
        dateRange = (0, _utils.formatDateRange)(line.Product.BeginDate, line.Product.EndDate);
      }

      var isSingleProdForced;
      if (line.Product.LinkingInfo && line.Product.LinkingInfo.ForcingMode === "Forced") {
        isSingleProdForced = true;
      }

      var isLinkedProduct;
      if (line.Product.LinkingInfo) {
        isLinkedProduct = true;
      }

      if (!line.IsDiscountProduct) {
        this.index++;
      }

      return {
        index: this.index,
        dateRange: dateRange,
        beginDate: (0, _moment2.default)(line.Product.BeginDate),
        endDate: (0, _moment2.default)(line.Product.EndDate),
        beginTime: line.Product.BeginTime,
        endTime: line.Product.EndTime,
        productName: line.Product.DestinationInfo.ProductName,
        destinationName: line.Product.DestinationInfo.DestinationName,
        productCode: line.Product.DestinationInfo.ProductCode,
        destinationCode: line.Product.DestinationInfo.DestinationCode,
        forced: !!line.PackageMemberIndex || isSingleProdForced || line.IsDiscountProduct,
        isLinkedProduct: isLinkedProduct,
        isAccommodation: lineIsAccommodation(line),
        isDiscountProduct: line.IsDiscountProduct,
        invalidDates: false,
        prices: matchSelectionsToPrices(line, this.$filter('i18next')),
        hideDates: line.Product.HideDates,
        extraQuestions: line.Product.ExtraQuestions,
        isChild: isDiscountForProductLine(line) || isServiceWithParent(line),
        hidden: line.hidden
      };
    }
  }, {
    key: 'remove',
    value: function remove(lineIndex, priceIndex) {
      if (priceIndex === undefined) {
        // Some custom templates might call this method the old way, with only the row index.
        // Log a warning and default to removing the first price selection (if the row is VV).
        console.warn('[WSC] No priceIndex provided. Update custom template to call $ctrl.remove with both parameters. Removing the first price on the row.');
        priceIndex = 0;
      }

      // The product lines in the cart. Note: They have the same indexes as
      // the "real" product lines in context.Products.
      var lines = this.contents;

      if (lineIndex >= 0 && priceIndex >= 0) {
        console.log("[WSC] Removing row from cart:", lineIndex, priceIndex);

        // Find the cart line affected. The line may contain multiple prices (rows in the table).
        var line = lines[lineIndex];
        if (!line) {
          console.warn('[WSC] Tried to remove non-existent line at index', lineIndex, ' - Lines:', lines);
        }

        // Find the cart price to remove. This corresponds to a single row in the table.
        var price = line.prices[priceIndex];
        if (!price) {
          console.warn('[WSC] Tried to remove non-existent price at index', priceIndex, ' - Prices:', line.prices);
        }

        // Find the matching product line in context.Products
        var productLine = this.data.Products[lineIndex];

        console.log('[WSC] Found matching product line:', productLine);

        // If the price being removed is not the only one included in the product line,
        // remove only the part (a transport stop, a price selection) that corresponds
        // to the price.
        // Otherwise, remove the entire line.
        var removeEntireLine = true;
        if (price.type === 'price-selection') {
          var selection = productLine.PriceSelections.splice(priceIndex, 1);
          console.log('[WSC] Removed price selection:', selection);
          // Update TotalPrice (and possibly UnitPrice)
          (0, _utils2.setLinePricesFromPriceSelections)(productLine);
          if (productLine.PriceSelections.length > 0) {
            // There are still other prices left, keep the line.
            removeEntireLine = false;
          }

          // Update product line amount by price selections.
          productLine.Amount = _.sumBy(productLine.PriceSelections, 'Amount');

          // Update product line price selections in shopping cart.
          this.updateContents();
        } else if (price.type === 'transport-stop') {
          var assignments = _.remove(productLine.PassengerAssignments, function (pa) {
            return pa.BusStopID === price.stopID;
          });
          console.log('[WSC] Removed transport passenger assignments:', assignments);

          // Update TotalPrice
          (0, _utils2.setLinePricesFromTransportPassengerAssignments)(productLine);

          if (productLine.PassengerAssignments.length > 0) {
            // There are still other stops left, keep the line.
            removeEntireLine = false;
          }
        }

        // Remove the product line, if applicable.
        if (removeEntireLine) {
          _.remove(this.data.Products, productLine);

          console.log('[WSC] Removed product line:', productLine);

          this.removePossibleChildren(productLine);

          // if (productLine.Product.DestinationInfo.Accommodation === true) {
          this.removePossibleForcedProducts(productLine);
          this.removePossibleLinkedProducts(productLine);
          this.removePossibleLinkedDiscounts(productLine);
          // }

          this.removePossibleDayLinkedProducts(productLine);

          if (lineIndex == 0 && priceIndex == 0) {
            // The top row was removed.
            // It is apparently assumed to be the accommodation.
            // Is that actually always correct?
            this.$rootScope.accommodationAddedToCart = false; // remove extra services add button.
          }

          this.$rootScope.$broadcast('remove-products-from-cart', [productLine]);
        } else {
          console.log('[WSC] Kept the product line:', productLine);
        }
      } else {
        console.error("[WSC] Tried to remove a line or a price with a negative index:", lineIndex, priceIndex);
      }
    }
  }, {
    key: 'getAmountOfBeds',
    value: function getAmountOfBeds() {
      var beds = {
        normal: 0, // adult or child
        child: 0 // child only
      };
      var accommodation = false;
      _.each(this.data.Products, function (p) {
        if (p.Product.DestinationInfo.Accommodation) {
          var info = p.Product.DestinationInfo;
          beds.normal += info.Beds * p.Amount;
          // TODO: Check a parameter for whether adults can be put in extra beds.
          beds.child += info.ExtraBeds * p.Amount;
          accommodation = true;
        }
      });

      if (!accommodation) {
        return {
          normal: 100,
          child: 100
        };
      }
      return beds;
    }

    // Return true[sic] if there are TOO MANY[sic] passengers to fit in the rooms.
    // Don't look at me, I didn't name this function.
    // I also can't rename it right now, since there it is used by some
    // externally-stored template in some weird /test123/ directory on the
    // server that I have no idea how to change.

  }, {
    key: 'enoughPpl',
    value: function enoughPpl() {
      var adults = this.data.NumAdults || 0;
      var children = this.data.NumChildren || 0;

      var beds = this.getAmountOfBeds();
      if (adults > beds.normal) {
        return true;
      }

      var bedsLeftForChildren = beds.normal - adults + beds.child;
      return children > bedsLeftForChildren;
    }
  }, {
    key: 'removePossibleChildren',
    value: function removePossibleChildren(productLine) {
      if (productLine && productLine.PackageRootIndex) {
        var packageIndex = productLine.PackageRootIndex;
        console.log('[WSC] Removing possible children of package', packageIndex);
        var childIndex = -1;
        while ((childIndex = this.findFirstChildIndex(packageIndex)) != -1) {
          console.log('[WSC] Removing child of package', packageIndex);
          this.remove(childIndex);
        }
      }
    }
  }, {
    key: 'findFirstChildIndex',
    value: function findFirstChildIndex(packageIndex) {
      return _.findIndex(this.data.Products, function (p) {
        return p.PackageMemberIndex == packageIndex;
      });
    }
  }, {
    key: 'removePossibleForcedProducts',
    value: function removePossibleForcedProducts(line) {
      var _this8 = this;

      if (line.Product && line.Product.DestinationInfo && line.Product.DestinationInfo.DestinationName) {
        var DestinationName = line.Product.DestinationInfo.DestinationName;
        _.each(this.contents, function (productInCart) {
          var parent = productInCart.isChild;

          // Check if product id forced and if it has the same destinationcode as removed product
          if (parent && productInCart.forced && productInCart.destinationName === DestinationName) {
            var linkedProduct = {
              Parent: {
                DestCode: productInCart.isChild.DestCode,
                ProdCode: productInCart.isChild.ProdCode,
                BeginDate: productInCart.isChild.BeginDate,
                EndDate: productInCart.isChild.EndDate
              }
            };

            if (isServiceFor(linkedProduct, line)) {
              console.log("[WSC] Removing forced product: ", productInCart);

              var productIndex = getLinkedServiceIndex(_this8.data.Products, linkedProduct);

              if (productIndex !== -1) {
                _this8.remove(productIndex);
              };
            }
          }
        });
      }
    }
  }, {
    key: 'removePossibleLinkedProducts',
    value: function removePossibleLinkedProducts(line) {
      var _this9 = this;

      if (line.Product && line.Product.DestinationInfo && line.Product.DestinationInfo.DestinationName) {
        var DestinationName = line.Product.DestinationInfo.DestinationName;
        _.each(this.contents, function (productInCart) {
          var parent = productInCart.isChild;
          if (parent && productInCart.isLinkedProduct) {
            var linkedProduct = {
              Parent: {
                DestCode: productInCart.isChild.DestCode,
                ProdCode: productInCart.isChild.ProdCode,
                BeginDate: productInCart.isChild.BeginDate,
                EndDate: productInCart.isChild.EndDate
              }

              // Check if product is linked product
            };if (isServiceFor(linkedProduct, line)) {
              console.log("[WSC] Removing linked product: ", productInCart);

              var productIndex = getLinkedServiceIndex(_this9.data.Products, linkedProduct);

              // this is here because the productIndex might be -1 because another function already removed the product
              if (productIndex !== -1) {
                _this9.remove(productIndex);
              }
            }
          }
        });
      }
    }
  }, {
    key: 'removePossibleLinkedDiscounts',
    value: function removePossibleLinkedDiscounts(line) {
      if (line.Product && line.Product.DestinationInfo && this.data.DiscountProducts) {
        this.data.DiscountProducts = _.filter(this.data.DiscountProducts, function (d) {
          return d.Product.Link.DestCode !== line.Product.DestinationInfo.DestinationCode && d.Product.Link.ProdCode !== line.Product.DestinationInfo.ProductCode;
        });

        // if (this.discountService.getDiscountCodeFromLocalStorage() 
        //  && this.data.DiscountProducts.length === 0) {
        //     // Empty discount code field.
        //     this.discountCode = '';

        //     this.discountService.removeDiscountCodeFromLocalStorage();
        // }
      }
    }

    // Remove possible day linked product siblings.

  }, {
    key: 'removePossibleDayLinkedProducts',
    value: function removePossibleDayLinkedProducts(line) {
      var _this10 = this;

      if (line.Product && line.Product.DestinationInfo && line.Product.LinkingInfo && line.Product.LinkingInfo.Type === 'Day') {
        _.each(this.data.Products, function (productLine, index) {
          if (productLine && productLine.Product.LinkingInfo && productLine.Product.LinkingInfo.Type === 'Day' && productLine.Product.DestinationInfo.DestinationCode === line.Product.DestinationInfo.DestinationCode && productLine.Product.DestinationInfo.ProductCode === line.Product.DestinationInfo.ProductCode) {
            _this10.remove(index);
          }
        });
      }
    }
  }, {
    key: 'findIndexOfProductInCart',
    value: function findIndexOfProductInCart(productInCart) {
      return _.findIndex(this.data.Products, function (p) {
        return p.Product.DestinationInfo.ProductCode === productInCart.productCode;
      });
    }
  }, {
    key: 'getTotal',
    value: function getTotal() {
      var total = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (this.contents || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (row.prices || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var price = _step2.value;

              // console.log(row, price, price.totalPrice, total);
              total += price.totalPrice || 0;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      total += this.$rootScope.reservationFee || 0;
      return total;
    }
  }, {
    key: 'getReservationFee',
    value: function getReservationFee() {
      var _this11 = this;

      // console.log("[WSC] getting reservation fee...");
      var WRC = this.winresReservationContext;
      var context = WRC.getContext();
      var products = context.Products;
      if (products) {
        // console.log("[WSC] getting reservation fee... products: ", products);

        this.productService.getReservationFee(products).then(function (result) {
          //   this.$rootScope.reservationFee is currently used in paybutton component
          if (result !== undefined) {
            if (result === null) {
              _this11.$rootScope.reservationFee = 0;
            } else {
              _this11.$rootScope.reservationFee = result.Amount;
            }
            // console.log("[WSC] reservation fee is: ", this.$rootScope.reservationFee);
          }
        }).catch(function (error) {
          console.error("There was an error retrieving the reservation fee: error: ", error);
        });
      } else {
        // console.log("[WSC] There seems to be no products. Skipping getting the reservation fee: products: ", products);
      }
    }
  }, {
    key: 'refreshTotalProductAmount',
    value: function refreshTotalProductAmount() {
      this.$scope.totalProductAmount = this.data.Products ? _.sumBy(this.data.Products, 'Amount') : 0;
    }

    // Check if accommodation extra service begin date is not in between accommodation begin and end date.
    // TODO: Move this check in backend.

  }, {
    key: 'findInvalidDateServices',
    value: function findInvalidDateServices(products) {
      var _this12 = this;

      this.hasInvalidDates = false;

      var invalidDateServices = _findInvalidDateServices(products);

      _.each(invalidDateServices, function (invalidDateService) {
        var service = findProductInContents(_this12.contents, invalidDateService);
        if (service !== undefined) {
          service.invalidDates = true;
          _this12.hasInvalidDates = true;
        }
      });

      if (this.hasInvalidDates) this.setError('reservation_extra_services.invalid_dates');else this.setError('');
    }
  }, {
    key: 'setError',
    value: function setError(error) {
      var errors = [];
      if (error) {
        errors.push({
          Message: error,
          Params: []
        });
      }
      this.winresReservationContext.setReservationComponentErrors('shopping_cart', 'shopping_cart', errors);
    }
  }, {
    key: 'getDate',
    value: function getDate(product) {
      return product.dateRange;
    }
  }]);

  return WinresShoppingCartController;
}();

function matchSelectionsToPrices(line, i18next) {
  if (line.IsService) {
    // Line generated by new winres-services component
    if (line.PriceSelections) {
      return _.map(line.PriceSelections, function (sel) {
        return {
          type: 'price-selection',
          amount: sel.Amount,
          label: i18next(sel.WS_PriceLabel) || sel.WS_PriceLabel,
          unitPrice: sel.WS_UnitPrice,
          totalPrice: sel.Amount * sel.WS_UnitPrice
        };
      });
    } else if (line.PassengerAssignments) {
      // Treat this as a single price.
      // If we want to display individual passengers, this can be changed.
      // In that case, we should probably also allow removing individual passengers.
      // That should be done similarly to how removing price selections and
      // transport stops works now.
      return [{
        type: 'single',
        amount: line.Amount,
        label: null,
        unitPrice: null,
        totalPrice: _.sumBy(line.PassengerAssignments, function (pa) {
          return pa.WS_Price;
        })
      }];
    } else {
      throw new Error('A service must have either PriceSelections or PassengerAssignments.');
    }
  } else if (line.PriceSelections != null && line.PriceSelections.length > 0) {
    // Old-style VV product (not generated by new winres-services component)
    // Price selections active (VV-product)
    // Show price labels in addition to product name etc.
    return _.map(line.PriceSelections, function (sel) {
      return matchSelectionToPrice(sel, line.Product.ReservablePrices, i18next);
    });
  } else if (line.IsTransport) {
    var passengersByStop = _.groupBy(line.PassengerAssignments, function (pa) {
      return pa.BusStopID;
    });
    return _.map(passengersByStop, function (assignments, stop) {
      return {
        type: 'transport-stop',
        totalPrice: 0,
        unitPrice: 0,
        amount: assignments.length,
        label: stop,
        stopID: stop
      };
    });
  } else if (line.TotalPrice) {
    return [{
      type: 'single',
      totalPrice: line.TotalPrice,
      unitPrice: line.UnitPrice,
      amount: line.Amount,
      label: null
    }];
  } else if (line.PriceIncludedInPackage) {
    return [{
      type: 'single',
      specialPrice: 'shopping_cart.price_included_in_package',
      totalPrice: null,
      unitPrice: null,
      amount: line.Amount,
      label: null
    }];
  } else {
    console.error('Virheellisesti / vanhaan malliin hinnoiteltu tuoterivi. Tämä voi johtua siitä että on asetettu pakotettuja tuotteita ja winres-reservation-extra-services:ss ei ole asetettu: no-forcings-if-activity="true" ');
    return [{
      type: 'single',
      totalPrice: null,
      unitPrice: null,
      label: null
    }];
  }
  /*
  else {
    // This might be an accommodation product / some other product where
    // prices are not selected (or the default price is being reserved). Just
    // print a single row wwith the product total.
    var unitPrice = parseFloat(line.Product.Price.replace(',', '.'));
    var dateRange;
    if (line.Product.ForceReservedDays > 0) {
      dateRange = formatFinnishDatePretty(line.Product.BeginDate);
    }
    else {
      dateRange = formatDateRange(line.Product.BeginDate, line.Product.EndDate);
    }
    return [{
      unitPrice: unitPrice,
      amount: line.Amount,
      label: line.Product.DestinationInfo.DestinationName + ': ' + line.Product.DestinationInfo.ProductName
        + ' ' +  (dateRange || ''),
    }];
  }
  */
}

function matchSelectionToPrice(priceSelection, reservablePrices, i18next) {
  var price = (0, _utils2.getReservablePriceForSelection)(priceSelection, reservablePrices);
  return {
    type: 'price-selection',
    amount: priceSelection.Amount,
    label: i18next(price.Label) || price.Label,
    unitPrice: price.Price,
    totalPrice: priceSelection.Amount * price.Price
  };
}

function orderProductLines(productLines) {
  // Make a copy to avoid mutating the original list,
  // in case the caller wants to keep using it.
  var unsorted = _.toArray(productLines);

  // Take any per-booking discounts.
  var perBookingDiscounts = _.remove(unsorted, isDiscountForBooking);

  // Take any per-line discounts.
  var perLineDiscounts = _.remove(unsorted, isDiscountForProductLine);

  // Take any services with a defined parent.
  var services = _.remove(unsorted, isServiceWithParent);

  // Anything remaining in the unsorted list at this point should be an independent product line.
  // Sort them, first by start date, then accommodations first.
  var mainLines = _.sortBy(unsorted, [function (line) {
    return line && line.Product && line.Product.BeginDate;
  }, function (line) {
    return lineIsAccommodation(line) ? 0 : 1;
  }]);

  // Make a list of lists, with each sub-list containing an independent line and
  // all the child lines that should go under it.
  var lineLists = _.map(unsorted, function (parentLine) {
    var discs = _.remove(perLineDiscounts, function (discountLine) {
      return isDiscountFor(discountLine, parentLine);
    });
    var sers = _.remove(services, function (serviceLine) {
      return isServiceFor(serviceLine, parentLine);
    });
    var sortedSers = _.sortBy(sers, [serviceSortKey]); // Sort forced services first
    return _.concat([parentLine], discs, sortedSers);
  });

  // These should have all been sorted under their parent lines.
  // Just in case, gather them up.
  var orphans = _.concat(perLineDiscounts, services);
  if (orphans.length > 0) {
    console.error('[WSC] Cart contains orphan product lines:', _.cloneDeep(orphans));
  }

  return _.concat(perBookingDiscounts, _.flatten(lineLists), orphans);
}

function isDiscountForBooking(line) {
  return line && line.IsDiscountProduct && line.DiscountScope === 'Booking';
}

function isDiscountForProductLine(line) {
  return line && line.IsDiscountProduct && line.DiscountScope === 'ProductLine';
}

function isServiceWithParent(line) {
  return line && line.Parent;
}

function isDiscountFor(discountLine, parentLine) {
  var d = discountLine && discountLine.Product && discountLine.Product.DestinationInfo;
  var p = parentLine && parentLine.Product && parentLine.Product.DestinationInfo;
  return d.DestinationCode === p.DestinationCode + '-DISCOUNT' && d.ProductCode === p.ProductCode + '-DISCOUNT';
}

function isServiceFor(serviceLine, parentLine) {
  return serviceLine && serviceLine.Parent && parentLine && parentLine.Product && parentLine.Product.DestinationInfo && serviceLine.Parent.DestCode === parentLine.Product.DestinationInfo.DestinationCode && (serviceLine.Parent.ProdCode === undefined || serviceLine.Parent.ProdCode === parentLine.Product.DestinationInfo.ProductCode) && serviceLine.Parent.BeginDate === parentLine.Product.BeginDate && serviceLine.Parent.EndDate === parentLine.Product.EndDate;
}

function serviceSortKey(serviceLine) {
  var p = serviceLine && serviceLine.Product;
  var li = p && p.LinkingInfo;
  return li && li.ForcingMode; // "Forced" sorts before "Normal"
}

function lineIsAccommodation(line) {
  var di = line && line.Product && line.Product.DestinationInfo;
  return di && di.Accommodation;
}

function _findInvalidDateServices(productLines) {
  // Take any services with a defined parent.
  var services = _.remove(productLines, isServiceWithParent);

  // Accommodations.
  var mainLines = _.remove(productLines, lineIsAccommodation);

  // Take services with BeginDate not in between accommodation BeginDate and EndDate.
  var invalidDateServices = _.map(mainLines, function (mainLine) {
    var sers = _.remove(services, function (serviceLine) {
      return isServiceFor(serviceLine, mainLine);
    });
    return _.remove(sers, function (serviceLine) {
      return (0, _moment2.default)(serviceLine.Product.BeginDate, 'YYYY-MM-DD') < (0, _moment2.default)(mainLine.Product.BeginDate, 'YYYY-MM-DD') || (0, _moment2.default)(serviceLine.Product.BeginDate, 'YYYY-MM-DD') > (0, _moment2.default)(mainLine.Product.EndDate, 'YYYY-MM-DD');
    });
  });

  return _.flatten(invalidDateServices);
}

function findProductInContents(contents, mainProduct) {
  // Get product from shopping cart contents.
  return _.find(contents, function (line) {
    return line.destinationCode === mainProduct.Product.DestinationInfo.DestinationCode && line.productCode === mainProduct.Product.DestinationInfo.ProductCode && line.beginDate.format('YYYY-MM-DD') == (0, _moment2.default)(mainProduct.Product.BeginDate).format('YYYY-MM-DD') && line.endDate.format('YYYY-MM-DD') == (0, _moment2.default)(mainProduct.Product.EndDate).format('YYYY-MM-DD');
  });
}

function getLinkedServiceIndex(productLines, serviceLine) {
  return _.findIndex(productLines, function (productLine) {
    return productLine.Parent !== undefined && productLine.Parent.DestCode === serviceLine.Parent.DestCode && productLine.Parent.ProdCode === serviceLine.Parent.ProdCode && productLine.Parent.BeginDate === serviceLine.Parent.BeginDate && productLine.Parent.EndDate === serviceLine.Parent.EndDate;
  });
}

function combineDayLinkedProducts(productLines) {
  // Make a copy to avoid mutating the original list.
  var copy = _.cloneDeep(productLines);

  // But make the extra questions list link to the original so
  // any changes made in the cart propagate back!
  for (var i = 0; i < productLines.length; ++i) {
    copy[i].Product.ExtraQuestions = productLines[i].Product.ExtraQuestions;
  }

  var lines = _.filter(copy, function (line) {
    return line.Product.LinkingInfo && line.Product.LinkingInfo.Type === 'Day';
  });

  _.each(lines, function (line) {
    return line.hidden = true;
  });

  // Create dest and prod code groups for day linked products.
  var dayLinkedProductGroupsByDestAndProdCode = _.groupBy(lines, function (line) {
    return line.Product.DestinationInfo.DestinationCode + '|' + line.Product.DestinationInfo.ProductCode;
  });

  // Combine day product prices, 
  // get lowest possible begin date and highest possible end date.
  // and make first day product visible in shopping cart.
  _.each(dayLinkedProductGroupsByDestAndProdCode, function (dayLinkedProducts) {
    var firstDayLinkedProduct = dayLinkedProducts[0];
    firstDayLinkedProduct.hidden = false;

    // Get lowest possible begin date and highest possible end date.
    var beginDate = firstDayLinkedProduct.Product.BeginDate;
    var endDate = dayLinkedProducts[dayLinkedProducts.length - 1].Product.BeginDate;

    firstDayLinkedProduct.Product.BeginDate = beginDate;
    firstDayLinkedProduct.Product.EndDate = endDate;

    // Combine prices.
    _.each(firstDayLinkedProduct.Product.ReservablePrices, function (reservablePrice, index) {
      reservablePrice.Price = _.sumBy(dayLinkedProducts, function (line) {
        return line.Product.ReservablePrices[index].Price;
      });
    });
  });

  return copy;
}

WinresShoppingCartController.$inject = ['$scope', '$filter', '$rootScope', '$q', 'userService', 'localizationService', 'messageService', 'cancelService', 'productService', 'discountService', '$timeout'];

function getTemplate($attrs, $sce) {
  // Default shopping cart call function
  if (!$attrs.call) {
    $attrs.call = "window.showShoppingBasket()";
  }

  return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'shopping-cart';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
  $templateCache.put('shopping-cart', require('./winresShoppingCart.html'));
}]);

_module3.default.component('winresShoppingCart', {
  templateUrl: getTemplate,
  controller: WinresShoppingCartController,
  require: {
    winresReservationContext: '?^^winresReservationContext'
  },
  bindings: {
    // string displayed when shopping cart is empty, if null, no text is displayed. Can be found in test123/shoppingTemplateUni.html
    noProductsText: '@',

    // Check if enough beds for adults and children
    checkPplAmount: '@',

    // function that triggers opening of the shopping cart, ex: window.showShoppingCart()
    call: '&',

    // Message code. default: WRCNOT
    messageCode: '@',

    // Show discount code input. true to enable, false to disable.
    showDiscountCode: '@',

    // Hide customer extra info text. true to hide, false or to show. Extra info text is shown by default.
    hideExtraInfo: '@',

    // If the cart needs to be placed outside <winres-reservation-context> (for example in a popup),
    // the context controller can be passed in this parameter.
    context: '<'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresShoppingCart/winresShoppingCart.js
// module id = 402
// module chunks = 2